module.exports = __webpack_public_path__ + "img/icon-bespoke-03.4c825fcd.svg";